import { CButton, CCol, CContainer, CFormLabel, CFormTextarea, CModal, CNav, CNavItem, CNavLink, CTabContent, CTabPane, CModalBody, CModalFooter, CModalHeader, CModalTitle, CRow, CTooltip } from '@coreui/react'
import React, { useEffect, useMemo, useState } from 'react'
import Graytextarea from '../../components/Graytextarea'
import SaveExtra from '../../services/general/saveExtraData.api'
import { Info, Plus } from 'lucide-react'
import { CAccordion, CAccordionBody, CAccordionHeader, CAccordionItem } from '@coreui/react'
import Editor, { Toolbar } from 'react-simple-wysiwyg'

import { CFormCheck } from '@coreui/react'
import FetchOrderForAssessment from './fetchOrderForAssessment'
import { readOnlyMode } from '@syncfusion/ej2-richtexteditor'
import BulletTextArea from '../../components/BulletTextArea'
import { buildHeaderPlanSelection, buildStatementPlanSelection, collectSelectedAssessmentOrderData, getSuggestionKey, getSuggestionText, getTitleKey, renderAssessmentSuggestionHtml, restoreAssessmentPlanSelections } from '../../utils/assessmentPlanSuggestions'

const getAccordionTitleLabel = (accordion) => {
  const title = accordion?.title?.trim() || ''
  const code = (accordion?.titleCode || accordion?.code || accordion?.Code || accordion?.icdCode || accordion?.ICDCode || accordion?.icd)?.toString().trim()

  if (!title) return code || ''
  if (!code || title.includes(`[${code}]`) || title.endsWith(code)) return title

  return `${title} [${code}]`
}

const AssessmentFinalNote = ({
  diagnosisName,
  saveTreatsShell,
  patientID,
  contentEditable = false,
  isTextInput,
  isAllotedToProvider,
  showDataIfNoteIsFollowUp = true,
  showTreatmentAsAccordion,
  patientTreatments,
  noteStructureRef,
  imagingTypeList,
  imaging,
  MasterDiagnosisData,
  medsRemarks,
  allLabs,
  diagnosisAddedPinger,
  medicationList,
  masterMedications,
  noteID,
  setAddedChangesToAssessment,
}) => {
  const [visible, setVisible] = useState(false)
  const [assessment, setAssessment] = useState('')
  const [freeType, setFreeType] = useState('')
  const [poa, setPoa] = useState('')
  const [assessmentSuggestions, setAssessmentSuggestions] = useState('')
  const [bimsScoreData, setBimsScoreData] = useState({
    score: '',
    date: '',
  })
  const [orderModalVisible, setOrderModalVisible] = useState(false)
  const [activeKey, setActiveKey] = useState(1)
  const [activeKey2, setActiveKey2] = useState(1)
  const [sugesstionsAssessmentsList, setSugesstionsAssessmentsList] = useState([]) //putting the fetched data

  const [showEditHtml, setShowEditHtml] = useState(false)
  const [tempHtmlContent, setTempHtmlContent] = useState('')

  const [showAssessmentEditHtml, setShowAssessmentEditHtml] = useState(false)
  const [tempAssessmentHtmlContent, setTempAssessmentHtmlContent] = useState('')

  const [assessmentFinalValue, setAssessmentFinalValue] = useState('')

  const [showItemsDescriptions, setShowItemsDescriptions] = useState([])
  const [selectedAssessmentSuggestionStrings, setSelectedAssessmentSuggestionString] = useState([])
  const [formattedSelectedPlanSuggestionsStrings, setFormattedSelectedPlanSuggestionsStrings] = useState([])
  const [selectedPlanSuggestion, setSelectedPlanSuggestion] = useState([])
  const [selectedIds, setSelectedId] = useState([])
  const [selectedOrder, setSelectedOrder] = useState([])
  let count = 0
  let newAssessment = ''
 const [showMediaModel, setShowMediaModel] = useState(false)

const [file, setFile] = useState([])
  useEffect(() => {
    if (noteStructureRef && noteStructureRef.current && noteStructureRef.current?.BIMSScore) {
      const bimsForCognitive = noteStructureRef?.current?.BIMSScore['Cognitive Communication Deficit']
      setBimsScoreData(bimsForCognitive)
    }
  }, [])

  useEffect(() => {
    if (patientTreatments && patientTreatments.length > 0) {
      let treatmentDetails = patientTreatments[noteID || 0]
      if (!treatmentDetails) {
        treatmentDetails = patientTreatments[0]
      }
      const { data } = treatmentDetails
      if (!noteStructureRef.current?.assessment) {
        noteStructureRef.current = {
          ...noteStructureRef.current,
          assessment: {
            ...noteStructureRef.current.assessment,
            [diagnosisName]: {
              MobilityAssessment: {},
              POA: '',
              MorseScore: {},
              LabImaging: '',
              FreeType: '',
              assessmentSuggestions: '',
              selfCareAssessment: {},
            },
          },
        }
      } else if (noteStructureRef.current?.assessment && !noteStructureRef.current?.assessment[diagnosisName]) {
        noteStructureRef.current = {
          ...noteStructureRef.current,
          assessment: {
            ...noteStructureRef.current.assessment,
            [diagnosisName]: {
              MobilityAssessment: {},
              POA: '',
              MorseScore: {},
              LabImaging: '',
              FreeType: '',
              selfCareAssessment: {},
            },
          },
        }
      } else if (noteStructureRef.current?.assessment && noteStructureRef.current?.assessment[diagnosisName]) {
        if (typeof data?.assessment?.[diagnosisName] === 'string') {
          noteStructureRef.current = {
            ...noteStructureRef.current,
            assessment: {
              ...noteStructureRef.current.assessment,
              [diagnosisName]: {
                MobilityAssessment: {},
                POA: '',
                MorseScore: {},
                LabImaging: '',
                FreeType: '',
                selfCareAssessment: {},
              },
            },
          }
        }
      }
      let existingAssessment = `${noteStructureRef.current?.assessment && noteStructureRef.current?.assessment[diagnosisName]?.LabImaging} ` || ''
      // const existingAssessment = (noteStructureRef.current?.assessment && noteStructureRef.current?.assessment[diagnosisName]) || "";

      if (existingAssessment.trim() === 'undefined' || existingAssessment === 'null') {
        existingAssessment = ''
      }
      let freeTypeData = (noteStructureRef.current?.assessment && noteStructureRef.current?.assessment[diagnosisName]?.FreeType) || ''
      let assessmentSuggestions = (noteStructureRef.current?.assessment && noteStructureRef.current?.assessment[diagnosisName]?.assessmentSuggestions) || ''
      // if (diagnosisName !== 'Falls') {
      //     existingAssessment = (noteStructureRef.current?.assessment && noteStructureRef.current?.assessment[diagnosisName]) || "";

      // } else {
      //     existingAssessment = (noteStructureRef.current?.assessment && noteStructureRef.current?.assessment[diagnosisName]?.LabImaging) || "";
      // }
      setAssessmentSuggestions(assessmentSuggestions)
      setFreeType(freeTypeData)
      setTempFreeType(freeTypeData)
      // newAssessment = existingAssessment || "";
    } else {
      noteStructureRef.current = {
        ...noteStructureRef.current,
        assessment: {
          ...noteStructureRef.current.assessment,
          [diagnosisName]: {
            MobilityAssessment: {},
            POA: '',
            MorseScore: {},
            LabImaging: '',
            FreeType: '',
            selfCareAssessment: {},
          },
        },
      }
    }

    let allImagingRemarks = []

    let lastLabsRemarks = []

    let standingMedicationTemplate = ''

    // let lastImaging = imaging && imaging.length > 0 && imaging[imaging.length - 1]

    const currentNoteImagings = imaging.filter((item) => noteStructureRef.current?.metadata?.imagingIds?.includes(item.id)) || []

    for (const patientImaging of currentNoteImagings) {
      if (imagingTypeList.length === 0 || !patientImaging?.data) continue

      const imagingImpression = patientImaging.data.impression?.toLowerCase() || ''
      const patientSelectedImaging = patientImaging.data.name?.toLowerCase() || ''

      const findMatchingImagingMaster = imagingTypeList.find((item) => item.Name.toLowerCase() === patientSelectedImaging)

      if (findMatchingImagingMaster) {
        let matchingDiagnosisImaging = []
        for (let keywordDetail of findMatchingImagingMaster.Keywords) {
          if (!keywordDetail?.keyword) continue
          const keywordsArray = keywordDetail.keyword
            .split(',')
            .map((keyword) => keyword.trim().toLowerCase())
            .filter((keyword) => keyword !== '')
          if (keywordsArray.some((item) => imagingImpression.includes(item?.toLowerCase()))) {
            matchingDiagnosisImaging.push(keywordDetail)
          }
        }
        for (const remarkD of matchingDiagnosisImaging) {
          for (const masterD of MasterDiagnosisData) {
            if (masterD.id === Number(remarkD.diagnosis)) {
              if (diagnosisName.trim() === masterD.Name.trim()) {
                allImagingRemarks.push({
                  ...masterD,
                  ...remarkD,
                  ...patientImaging,
                })
              }
            }
          }
        }
      }
    }

    if (allLabs.length > 0) {
      const lastLab = allLabs[0] || []

      const lastLabArrOfLabs = lastLab?.data || []

      let allMatchingLab = lastLabArrOfLabs.filter((item) => {
        const diagnosisLab = item.diagnosis.split(',').filter((item) => item !== '')
        return diagnosisLab.some((diagn) => diagn.includes(diagnosisName))
      })

      lastLabsRemarks = allMatchingLab.map((item) => item.remark).filter((item) => item !== '')
    }

    if (lastLabsRemarks.length > 0) {
      const lastLabsRemarksText = lastLabsRemarks.join('\n')

      if (!newAssessment.includes(lastLabsRemarksText)) {
        if (newAssessment !== '') {
          newAssessment += '\n'
        }
        newAssessment += lastLabsRemarksText
      }
    }

    const imagingRemarksText = allImagingRemarks
      .map((item) => item?.remarks)
      .filter(Boolean)
      .join('\n')

    if (imagingRemarksText) {
      if (!newAssessment.includes(imagingRemarksText)) {
        if (newAssessment !== '') {
          newAssessment += '\n'
        }
        newAssessment += imagingRemarksText
      }

      // newAssessment += allImagingRemarks?.remarks; // turn this on
    }

    // if (standingMedicationTemplate && standingMedicationTemplate !== '') {
    //     if (newAssessment !== '') {
    //         newAssessment += '\n\n';
    //     }
    //     newAssessment += standingMedicationTemplate;
    // }

    // if (newAssessment.trim() !== '') {
    //     const existingAssessment = noteStructureRef.current.assessment?.[diagnosisName];

    //     if (existingAssessment !== newAssessment) {

    //         setAssessment(newAssessment);

    //         noteStructureRef.current = {
    //             ...noteStructureRef.current,
    //             assessment: {
    //                 ...noteStructureRef.current.assessment,
    //                 [diagnosisName]: newAssessment,
    //             },
    //         };
    //     } else {
    //         console.log("Duplicate assessment not added");
    //     }
    // }

    // if (newAssessment.trim !== '') {
    //     setAssessment(newAssessment);
    //     noteStructureRef.current = {
    //         ...noteStructureRef.current,
    //         assessment: {
    //             ...noteStructureRef.current.assessment,
    //             [diagnosisName]: {
    //                 ...noteStructureRef.current.assessment[diagnosisName] || {
    //                     MobilityAssessment: {},
    //                     POA: "",
    //                     MorseScore: {},
    //                     LabImaging: "",
    //                     FreeType: "",
    //                 },
    //                 LabImaging: newAssessment || '',
    //             }
    //         }
    //     }
    // }

    if (newAssessment.trim() !== '' && newAssessment.trim() !== 'undefined' && newAssessment !== 'null') {
      setAssessment(newAssessment)

      const currentAssessment = noteStructureRef.current.assessment || {}
      const existingDiagnosisData = currentAssessment[diagnosisName] || {
        MobilityAssessment: {},
        POA: '',
        MorseScore: {},
        LabImaging: '',
        FreeType: '',
      }

      noteStructureRef.current = {
        ...noteStructureRef.current,
        assessment: {
          ...currentAssessment,
          [diagnosisName]: {
            ...existingDiagnosisData,
            LabImaging: newAssessment || '',
          },
        },
      }
    }
    // setAssessment(newAssessment);
    // noteStructureRef.current = {
    //     ...noteStructureRef.current,
    //     assessment: {
    //         ...noteStructureRef.current.assessment,
    //         [diagnosisName]: {
    //             ...noteStructureRef.current.assessment[diagnosisName],
    //             LabImaging: newAssessment || '',
    //         }
    //     }
    // };
  }, [imaging, imagingTypeList, diagnosisAddedPinger, allLabs, noteStructureRef])

  // Freetype center
  const [tempFreeType, setTempFreeType] = useState('')
  const [visibleModalTempFreeType, setVisibleModalTempFreeType] = useState(false)
  // const handleFreeTypeChanges = async(value) => {
  //     setFreeType(value);
  //     noteStructureRef.current = {
  //         ...noteStructureRef.current,
  //         assessment: {
  //             ...noteStructureRef.current.assessment,
  //             [diagnosisName]: {
  //                 ...noteStructureRef.current.assessment[diagnosisName],
  //                 FreeType: value
  //             }
  //         }
  //     };
  //     // await saveTreatsShell(false)
  // }
  const handleSaveFreetype = async () => {
    setVisibleModalTempFreeType(false)
    noteStructureRef.current = {
      ...noteStructureRef.current,
      assessment: {
        ...noteStructureRef.current.assessment,
        [diagnosisName]: {
          ...noteStructureRef.current.assessment[diagnosisName],
          FreeType: tempFreeType,
        },
      },
    }
    setFreeType(tempFreeType)
    await saveTreatsShell(false)
  }
  // Freetype center
  // const handleChanges = async(e) => {
  //     const { value } = e.target;
  //     setFreeType(value);
  //     noteStructureRef.current = {
  //         ...noteStructureRef.current,
  //         assessment: {
  //             ...noteStructureRef.current.assessment,
  //             [diagnosisName]: {
  //                 ...noteStructureRef.current.assessment[diagnosisName],
  //                 FreeType: value || '',
  //             }
  //         }
  //     };
  //     // await saveTreatsShell(false)
  // };

  const handlePoaChange = (value) => {
    setPoa(value)
    noteStructureRef.current = {
      ...noteStructureRef.current,
      assessment: {
        ...noteStructureRef.current.assessment,
        [diagnosisName]: {
          ...noteStructureRef.current.assessment[diagnosisName],
          POA: value,
        },
      },
    }
  }

  const handleLabsChanges = (value) => {
    setAssessment(value)
    noteStructureRef.current = {
      ...noteStructureRef.current,
      assessment: {
        ...noteStructureRef.current.assessment,
        [diagnosisName]: {
          ...noteStructureRef.current.assessment[diagnosisName],
          LabImaging: value,
        },
      },
    }
  }

  // useEffect(() => {
  //     if (!noteStructureRef.current.assessment) {
  //         noteStructureRef.current.assessment = {};
  //     }

  //     if (!noteStructureRef.current.assessment[diagnosisName]) {
  //         noteStructureRef.current.assessment[diagnosisName] = {};
  //     }

  //     noteStructureRef.current = {
  //         ...noteStructureRef.current,
  //         assessment: {
  //             ...noteStructureRef.current.assessment,
  //             [diagnosisName]: {
  //                 ...noteStructureRef.current.assessment[diagnosisName],
  //                 assessmentSuggestions: assessmentSuggestions,
  //             },
  //         },
  //     };
  // }, [assessmentSuggestions]);

  // useEffect(()=>{
  //     // planSuggestion
  //     const assessmentSuggestionAdded = noteStructureRef?.current?.assessment?.[diagnosisName]?.assessmentSuggestions
  //     const planSuggestionAdded = noteStructureRef?.current?.plans?.[diagnosisName]?.planSuggestion;
  //     if(assessmentSuggestionAdded){
  //         const splittedArrayAssessmentSuggestion = assessmentSuggestionAdded.split('\n');
  //         if(splittedArrayAssessmentSuggestion.length > 0){

  //         }
  //         setSelectedAssessmentSuggestionString(splittedArrayAssessmentSuggestion)
  //     }
  //     if(planSuggestionAdded){
  //         const splittedArrayPlan = planSuggestionAdded.split('\n');
  //         setSelectedPlanSuggestionsStrings(splittedArrayPlan)
  //     }
  // },[])
  const getAncestorTitleKeys = (targetKey, accordions, parentTitleKeys = []) => {
    for (const accordion of accordions || []) {
      const currentTitleKey = getTitleKey(accordion.id)
      const nextParentTitleKeys = [...parentTitleKeys, currentTitleKey]
      const suggestions = accordion?.suggestions?.suggestionName || []

      if (currentTitleKey === targetKey) return parentTitleKeys

      const hasMatchingSuggestion = suggestions.some((suggestion) => getSuggestionKey(accordion.id, suggestion) === targetKey)

      if (hasMatchingSuggestion) return nextParentTitleKeys

      if (accordion.children?.length) {
        const nestedAncestorKeys = getAncestorTitleKeys(targetKey, accordion.children, nextParentTitleKeys)
        if (nestedAncestorKeys.length > 0) return nestedAncestorKeys
      }
    }

    return []
  }

  const getHeaderPlanSelectionsForKeys = (titleKeys) => {
    const selectedTitleKeySet = new Set(titleKeys || [])
    const planSelections = []

    const visit = (accordions) => {
      for (const accordion of accordions || []) {
        const titleKey = getTitleKey(accordion.id)

        if (selectedTitleKeySet.has(titleKey)) {
          const headerPlan = buildHeaderPlanSelection(accordion, getAccordionTitleLabel(accordion))

          if (headerPlan) {
            planSelections.push(headerPlan)
          }
        }

        if (accordion.children?.length) {
          visit(accordion.children)
        }
      }
    }

    visit(sugesstionsAssessmentsList)

    return planSelections
  }

  const mergePlanSelections = (currentSelections, selectionsToAdd) => {
    const merged = [...currentSelections]

    selectionsToAdd.filter(Boolean).forEach((selection) => {
      if (!merged.some((item) => item.key === selection.key)) {
        merged.push(selection)
      }
    })

    return merged
  }

  const normalizeSelectionText = (value) => String(value || '').trim().replace(/^[•*-]\s*/, '').replace(/:$/, '').trim().toLowerCase()

  const addAssessmentKeyWithAncestors = (keys, key) => {
    if (!key || keys.includes(key)) return

    keys.push(key)
    getAncestorTitleKeys(key, sugesstionsAssessmentsList).forEach((ancestorKey) => {
      if (!keys.includes(ancestorKey)) keys.push(ancestorKey)
    })
  }

  const collectLegacyAssessmentKeys = (assessmentText) => {
    const textLines = String(assessmentText || '')
      .split('\n')
      .map((line) => normalizeSelectionText(line))
      .filter(Boolean)
    const keys = []

    const visit = (accordions) => {
      for (const accordion of accordions || []) {
        const titleText = normalizeSelectionText(getAccordionTitleLabel(accordion))

        if (titleText && textLines.includes(titleText)) {
          addAssessmentKeyWithAncestors(keys, getTitleKey(accordion.id))
        }

        accordion?.suggestions?.suggestionName?.forEach((suggestion) => {
          const suggestionText = normalizeSelectionText(getSuggestionText(suggestion))

          if (suggestionText && textLines.includes(suggestionText)) {
            addAssessmentKeyWithAncestors(keys, getSuggestionKey(accordion.id, suggestion))
          }
        })

        if (accordion.children?.length) visit(accordion.children)
      }
    }

    visit(sugesstionsAssessmentsList)
    return keys
  }

  const collectPlanSources = () => {
    const sources = []

    const visit = (accordions) => {
      for (const accordion of accordions || []) {
        const headerPlan = buildHeaderPlanSelection(accordion, getAccordionTitleLabel(accordion))
        if (headerPlan) sources.push(headerPlan)

        accordion?.suggestions?.suggestionName?.forEach((suggestion) => {
          const statementPlan = buildStatementPlanSelection(accordion, suggestion)
          if (statementPlan) sources.push(statementPlan)
        })

        if (accordion.children?.length) visit(accordion.children)
      }
    }

    visit(sugesstionsAssessmentsList)
    return [...new Map(sources.map((source) => [source.key, source])).values()]
  }

  const getPlanOptionKey = (source, suggestion, index) => {
    const optionId = suggestion?.id ?? suggestion?.ID ?? suggestion?.key ?? 'index'
    return `plan-option::${source.key}::${optionId}::${index}`
  }

  const getLegacyPlanOptionKey = (source, suggestion) => `${source.name}::${getSuggestionText(suggestion)}`

  const restorePlanSelectionValues = (planText, storedValues, planSources) => {
    const storedValueSet = new Set((Array.isArray(storedValues) ? storedValues : []).map((value) => normalizeSelectionText(value)))
    const planTextChildrenByParent = new Map()
    let currentParent = ''

    String(planText || '').split('\n').forEach((line) => {
      const normalizedLine = normalizeSelectionText(line)
      if (!normalizedLine) return

      const indentation = line.match(/^[\t ]*/)?.[0] || ''
      if (indentation.length === 0) {
        currentParent = normalizedLine
        if (!planTextChildrenByParent.has(currentParent)) planTextChildrenByParent.set(currentParent, new Set())
        return
      }

      if (currentParent) {
        planTextChildrenByParent.get(currentParent)?.add(normalizedLine)
      }
    })

    const restoredValues = []
    const usedLegacyValues = new Set()

    planSources.forEach((source) => {
      const sourceName = normalizeSelectionText(source.name)
      const sourceStoredValues = [...storedValueSet].filter((value) => value.startsWith(`${sourceName}::`))
      const textChildren = planTextChildrenByParent.get(sourceName) || new Set()

      source.suggestions.forEach((suggestion, index) => {
        const suggestionText = getSuggestionText(suggestion)
        const optionKey = getPlanOptionKey(source, suggestion, index)
        const legacyOptionKey = normalizeSelectionText(getLegacyPlanOptionKey(source, suggestion))
        const childIsInText = textChildren.has(normalizeSelectionText(suggestionText))
        const hasStoredUniqueValue = storedValueSet.has(normalizeSelectionText(optionKey))
        const hasStoredLegacyValue = sourceStoredValues.includes(legacyOptionKey) && !usedLegacyValues.has(legacyOptionKey)
        const hasTextValue = childIsInText && !usedLegacyValues.has(legacyOptionKey)

        if (hasStoredUniqueValue || hasStoredLegacyValue || hasTextValue) {
          restoredValues.push(optionKey)
          if (hasStoredLegacyValue || hasTextValue) usedLegacyValues.add(legacyOptionKey)
        }
      })
    })

    return [...new Set(restoredValues)]
  }

  const toggleAssessmentKey = (key, shouldSelect) => {
    const applySelectionUpdate = (prev) => {
      if (shouldSelect) {
        const nextKeys = prev.includes(key) ? [...prev] : [...prev, key]
        const ancestorTitleKeys = getAncestorTitleKeys(key, sugesstionsAssessmentsList)

        ancestorTitleKeys.forEach((ancestorKey) => {
          if (!nextKeys.includes(ancestorKey)) {
            nextKeys.push(ancestorKey)
          }
        })

        return nextKeys
      }

      return prev.filter((item) => item !== key)
    }

    setSelectedAssessmentSuggestionString(applySelectionUpdate)
    setSelectedId(applySelectionUpdate)
  }

  useEffect(() => {
    const selectedAssessmentIds = noteStructureRef?.current?.assessment?.[diagnosisName]?.formattedSelectedSuggestionIdString
    const storedKeys = typeof selectedAssessmentIds === 'string' ? selectedAssessmentIds.split('\n').filter(Boolean) : []
    const assessmentSuggestionAdded = noteStructureRef?.current?.assessment?.[diagnosisName]?.assessmentSuggestions || ''
    const planData = noteStructureRef?.current?.plans?.[diagnosisName] || {}
    const planSources = collectPlanSources()
    const storedPlanSelections = Array.isArray(planData.formattedSelectedPlanSuggestionsStrings)
      ? planData.formattedSelectedPlanSuggestionsStrings
      : []

    const assessmentKeys = storedKeys.length > 0 ? [...storedKeys] : collectLegacyAssessmentKeys(assessmentSuggestionAdded)
    assessmentKeys.slice().forEach((key) => addAssessmentKeyWithAncestors(assessmentKeys, key))
    const restoredPlanValues = restorePlanSelectionValues(planData.planSuggestion, storedPlanSelections, planSources)
    const planSourcesWithSelections = planSources.filter((source) => restoredPlanValues.some((value) => value.startsWith(`plan-option::${source.key}::`)))

    planSourcesWithSelections.forEach((source) => addAssessmentKeyWithAncestors(assessmentKeys, source.key))

    const restored = restoreAssessmentPlanSelections(sugesstionsAssessmentsList, assessmentKeys, getAccordionTitleLabel)
    const formattedPlanSelections = restoredPlanValues.length > 0 ? restoredPlanValues : storedPlanSelections

    setSelectedAssessmentSuggestionString(restored.assessmentKeys)
    setSelectedPlanSuggestion(restored.planSources)
    setSelectedId(restored.assessmentKeys)
    setFormattedSelectedPlanSuggestionsStrings(formattedPlanSelections)

    if (assessmentSuggestionAdded || restored.assessmentKeys.length > 0) {
      const restoredAssessmentText = getAssessmentBulletText(sugesstionsAssessmentsList, restored.assessmentKeys).join('\n')
      setAssessmentFinalValue(
        mergeAssessmentSuggestionText(restoredAssessmentText, assessmentSuggestionAdded, sugesstionsAssessmentsList)
      )
    }
  }, [diagnosisName, sugesstionsAssessmentsList])
 const handleConvertAndOpenMedia = (accordion) => {
  const attached = accordion?.attached || {}

  const convertedData = Object.entries(attached).flatMap(([type, files]) =>
    (Array.isArray(files) ? files : []).map((item) => ({
      url: typeof item === 'object' ? item?.url : item,
      type,
      fileName:
        typeof item === 'object'
          ? item?.fileName || item?.url?.split('/').pop() || ''
          : item?.split('/').pop() || '',
    }))
  ).filter(item => item.url)

  setFile(convertedData)
  setShowMediaModel(true)
}
  const getAllDiagnosisDifferential = async () => {
    let data = await SaveExtra('Get_By_Type', 'AssesmentSuggestions', '', '')
    data = JSON.parse(data.d)?.Data || []

    if (data) {
      data = data.map((item) => ({
        Id: item.Id,
        Data: JSON.parse(item?.JsonData),
      }))
    }

    const findAssessmentSuggestionForDiagnosis = data.find((item) => item?.Data?.diagnosis?.label?.trim()?.toLowerCase() === diagnosisName?.trim()?.toLowerCase())
    setSugesstionsAssessmentsList(findAssessmentSuggestionForDiagnosis?.Data?.accordions || [])
  }

  useEffect(() => {
    if (!diagnosisName) return
    getAllDiagnosisDifferential()
  }, [diagnosisName])

  const renderSuggestions = (accordion) => (
    <>
      {accordion.suggestions?.suggestionName?.map((item) => {
        const suggestionName = getSuggestionText(item)
        if (!suggestionName) return null
        const suggestionKey = getSuggestionKey(accordion.id, item)

        return (
          <div key={suggestionKey}>
            <div className="d-flex align-items-center gap-2">
              <CFormCheck
                checked={selectedAssessmentSuggestionStrings.includes(suggestionKey)}
                onChange={() => {
                  const isAlreadySelected = selectedAssessmentSuggestionStrings.includes(suggestionKey)

                  if (isAlreadySelected) {
                    toggleAssessmentKey(suggestionKey, false)
                    setSelectedPlanSuggestion((prev) => prev.filter((s) => s.key !== suggestionKey))
                  } else {
                    toggleAssessmentKey(suggestionKey, true)

                    const planSelection = buildStatementPlanSelection(accordion, item)
                    const ancestorPlanSelections = getHeaderPlanSelectionsForKeys(getAncestorTitleKeys(suggestionKey, sugesstionsAssessmentsList))

                    setSelectedPlanSuggestion((prev) => mergePlanSelections(prev, [planSelection, ...ancestorPlanSelections]))
                  }
                }}
                id={`suggestion-${suggestionKey}`}
                label={suggestionName}
              />

              {item?.description && (
                <span
                  className="d-inline-flex align-items-center"
                  style={{ cursor: 'pointer' }}
                  onClick={() =>
                    setShowItemsDescriptions((prev) =>
                      prev.includes(`suggestion-${suggestionKey}`) ? prev.filter((id) => id !== `suggestion-${suggestionKey}`) : [...prev, `suggestion-${suggestionKey}`],
                    )
                  }
                >
                  <Info strokeWidth={1} size={16} />
                </span>
              )}
            </div>
            {showItemsDescriptions.includes(`suggestion-${suggestionKey}`) && <div style={{ color: 'orange', whiteSpace: 'pre-line', fontSize: '12px', padding: '8px 10px' }}>{item?.description}</div>}
          </div>
        )
      })}
    </>
  )

  useEffect(() => {
    setSelectedOrder(collectSelectedAssessmentOrderData(sugesstionsAssessmentsList, selectedAssessmentSuggestionStrings))
  }, [sugesstionsAssessmentsList, selectedAssessmentSuggestionStrings])

  const renderNestedAccordions = (accordions) => {
    return (
      <CAccordion className="assessment-suggestion-modal__accordion">
        {accordions.map((accordion, index) => {
            const hasTitle = accordion?.title && accordion.title.trim() !== ''
            const hasSuggestions = (accordion?.suggestions?.suggestionName || []).length > 0
            const hasChildren = (accordion?.children || []).length > 0
            const titleKey = getTitleKey(accordion.id)
            const isTitleSelected = selectedAssessmentSuggestionStrings.includes(titleKey)

            return (
              hasTitle ? (
                <CAccordionItem itemKey={accordion.id || index} key={accordion.id || index}>
                  <CAccordionHeader>
                    <div className="gap-2 d-flex align-items-center justify-content-left w-100">
                      <div className="d-flex align-items-center gap-2">
                        <CFormCheck
                          className="mb-0"
                          id={`title-${titleKey}`}
                          checked={isTitleSelected}
                          onMouseDown={(event) => event.stopPropagation()}
                          onClick={(event) => event.stopPropagation()}
                          onChange={(event) => {
                            const shouldSelect = event.target.checked
                            toggleAssessmentKey(titleKey, shouldSelect)
                            setSelectedPlanSuggestion((prev) => {
                              if (!shouldSelect) return prev.filter((item) => item.key !== titleKey)
                              const headerPlan = buildHeaderPlanSelection(accordion, getAccordionTitleLabel(accordion))
                              return mergePlanSelections(prev, [headerPlan])
                            })
                          }}
                        />
                        <span>{getAccordionTitleLabel(accordion)}</span>
                      </div>
                      {accordion?.description && (
                        <span
                          className="d-inline-flex align-items-center"
                          style={{ cursor: 'pointer' }}
                          onClick={(event) => {
                            event.stopPropagation()
                            const descriptionKey = `accordion-${accordion.id || index}`
                            setShowItemsDescriptions((prev) => (prev.includes(descriptionKey) ? prev.filter((id) => id !== descriptionKey) : [...prev, descriptionKey]))
                          }}
                        >
                          <Info strokeWidth={2} size={18} />
                        </span>
                      )}
                      {accordion?.attached?.image?.length > 0 && (
 <span
  className="d-inline-flex align-items-center justify-content-center"
  style={{
    width: '20px',
    height: '20px',
    minWidth: '20px',
    boxSizing: 'border-box',
    border: '2px solid currentColor',
    borderRadius: '50%',
    fontSize: '12px',
    lineHeight: '20px',
    textAlign: 'center',
    padding: 0,
    flexShrink: 0,
    cursor: 'pointer',
    fontFamily: 'Arial, sans-serif',
  }}
  title="View attachments"
  onClick={(e) => {
    e.stopPropagation()
    handleConvertAndOpenMedia(accordion)
  }}
>
  e
</span>
)}
                    </div>
                  </CAccordionHeader>
                  {showItemsDescriptions.includes(`accordion-${accordion.id || index}`) && <div style={{ color: 'orange', whiteSpace: 'pre-line', fontSize: '12px', padding: '8px 10px' }}>{accordion.description}</div>}
                  <CAccordionBody>
                    {hasSuggestions && renderSuggestions(accordion)}
                    {hasChildren && renderNestedAccordions(accordion.children)}
                  </CAccordionBody>
                </CAccordionItem>
              ) : (
                <div key={accordion.id || index}>
                  {hasSuggestions && renderSuggestions(accordion)}
                  {hasChildren && renderNestedAccordions(accordion.children)}
                </div>
              )
            )
          })}
      </CAccordion>
    )
  }

  const renderAccordions = () => {
    if (sugesstionsAssessmentsList?.length) {
      return renderNestedAccordions(sugesstionsAssessmentsList)
    }
    return null
  }

  const getFormattedTitleLine = (accordion, level, hasSelectedSubData = false) => {
    const titleLabel = getAccordionTitleLabel(accordion)

    if (!titleLabel) return ''
    if (level === 0 && hasSelectedSubData && !titleLabel.endsWith(':')) return `${titleLabel}:`

    return titleLabel
  }

  const getAssessmentBulletText = (accordions, selectedKeys, level = 0) => {
    const lines = []

    accordions?.forEach((accordion) => {
      const children = accordion.children || []
      const titleKey = getTitleKey(accordion.id)
      const isTitleSelected = selectedKeys.includes(titleKey)

      const hasSelectedSubData = (items) =>
        items.some((item) => {
          const hasSelectedSuggestion = item?.suggestions?.suggestionName?.some((suggestion) => selectedKeys.includes(getSuggestionKey(item.id, suggestion)))

          return hasSelectedSuggestion || hasSelectedSubData(item.children || [])
        })

      const hasSelectedDescendant = (items) =>
        items.some((item) => {
          const hasSelectedTitle = selectedKeys.includes(getTitleKey(item.id))
          const hasSelectedSuggestion = item?.suggestions?.suggestionName?.some((suggestion) => selectedKeys.includes(getSuggestionKey(item.id, suggestion)))

          return hasSelectedTitle || hasSelectedSuggestion || hasSelectedDescendant(item.children || [])
        })

      if (!isTitleSelected && !hasSelectedDescendant([accordion])) return

      lines.push(`${'  '.repeat(level)}${getFormattedTitleLine(accordion, level, hasSelectedSubData([accordion]))}`)

      accordion.suggestions?.suggestionName?.forEach((suggestion) => {
        const key = getSuggestionKey(accordion.id, suggestion)
        const suggestionText = getSuggestionText(suggestion)

        if (suggestionText && selectedKeys.includes(key)) {
          lines.push(`${'  '.repeat(level + 1)}• ${suggestionText}`)
        }
      })

      if (children.length) {
        lines.push(...getAssessmentBulletText(children, selectedKeys, level + 1))
      }
    })

    return lines
  }

  const normalizeAssessmentLine = (line) => String(line || '').trim().replace(/\s+/g, ' ').toLowerCase()

  const getAssessmentLineKey = (line) =>
    normalizeAssessmentLine(line).replace(/^(?:[•\-*]\s*)+/, '')

  const getAssessmentLines = (text) =>
    String(text || '')
      .replace(/\r\n/g, '\n')
      .split('\n')
      .map((line) => line.trimEnd())
      .filter((line) => line.trim())

  const getAllAssessmentSuggestionLineSet = (accordions) => {
    const lines = new Set()

    const addLine = (line) => {
      const normalizedLine = normalizeAssessmentLine(line)

      if (normalizedLine) lines.add(normalizedLine)
    }

    const visit = (items) => {
      for (const accordion of Array.isArray(items) ? items : []) {
        const titleLabel = getAccordionTitleLabel(accordion)

        if (titleLabel) {
          addLine(titleLabel)
          addLine(`${titleLabel}:`)
        }

        const suggestions = Array.isArray(accordion?.suggestions?.suggestionName) ? accordion.suggestions.suggestionName : []

        suggestions.forEach((suggestion) => {
          const suggestionText = getSuggestionText(suggestion)

          if (suggestionText) {
            addLine(suggestionText)
            addLine(`- ${suggestionText}`)
            addLine(`• ${suggestionText}`)
          }
        })

        visit(accordion?.children)
      }
    }

    visit(accordions)
    return lines
  }

  const mergeAssessmentSuggestionText = (selectedSuggestionText, currentText, accordions) => {
    const selectedLines = getAssessmentLines(selectedSuggestionText)
    const currentLines = getAssessmentLines(currentText)
    const knownSuggestionLines = getAllAssessmentSuggestionLineSet(accordions)
    const selectedLineIndexes = new Map()
    const existingSelectedLines = new Map()
    const manualLinesByAnchor = new Map()
    let lastSelectedLineIndex = -1
    let hasCurrentSuggestionLine = false

    selectedLines.forEach((line, index) => {
      const lineKey = getAssessmentLineKey(line)

      if (lineKey && !selectedLineIndexes.has(lineKey)) {
        selectedLineIndexes.set(lineKey, index)
      }
    })

    currentLines.forEach((line) => {
      const normalizedLine = normalizeAssessmentLine(line)
      const lineKey = getAssessmentLineKey(line)
      const selectedLineIndex = selectedLineIndexes.get(lineKey)
      const isSuggestionLine =
        knownSuggestionLines.has(normalizedLine) ||
        knownSuggestionLines.has(lineKey)

      if (isSuggestionLine) {
        hasCurrentSuggestionLine = true

        if (selectedLineIndex !== undefined) {
          if (!existingSelectedLines.has(selectedLineIndex)) {
            existingSelectedLines.set(selectedLineIndex, line)
          }
          lastSelectedLineIndex = selectedLineIndex
        }
        return
      }

      if (lineKey) {
        const anchoredLines = manualLinesByAnchor.get(lastSelectedLineIndex) || []
        anchoredLines.push(line)
        manualLinesByAnchor.set(lastSelectedLineIndex, anchoredLines)
      }
    })

    const mergedLines = []
    const seenLines = new Set()
    const addUniqueLine = (line) => {
      const normalizedLine = normalizeAssessmentLine(line)

      if (!normalizedLine || seenLines.has(normalizedLine)) return

      seenLines.add(normalizedLine)
      mergedLines.push(line)
    }

    if (hasCurrentSuggestionLine) {
      manualLinesByAnchor.get(-1)?.forEach(addUniqueLine)
    }

    selectedLines.forEach((line, index) => {
      addUniqueLine(existingSelectedLines.get(index) || line)
      manualLinesByAnchor.get(index)?.forEach(addUniqueLine)
    })

    if (!hasCurrentSuggestionLine) {
      manualLinesByAnchor.get(-1)?.forEach(addUniqueLine)
    }

    return mergedLines.join('\n')
  }

  useEffect(() => {
    if (activeKey !== 1) return

    const bulletLines = getAssessmentBulletText(sugesstionsAssessmentsList, selectedAssessmentSuggestionStrings)
    const selectedSuggestionText = bulletLines.join('\n')

    setAssessmentFinalValue((currentValue) => mergeAssessmentSuggestionText(selectedSuggestionText, currentValue, sugesstionsAssessmentsList))
  }, [activeKey, selectedAssessmentSuggestionStrings, sugesstionsAssessmentsList, visible])

  const displayedAssessmentSuggestions = useMemo(() => {
    const storedSelectedIds = (noteStructureRef?.current?.assessment?.[diagnosisName]?.formattedSelectedSuggestionIdString || '')
      .split('\n')
      .map((item) => item.trim())
      .filter(Boolean)

    if (sugesstionsAssessmentsList?.length && storedSelectedIds.length > 0) {
      const bulletLines = getAssessmentBulletText(sugesstionsAssessmentsList, storedSelectedIds)

      if (bulletLines.length > 0) {
        return mergeAssessmentSuggestionText(bulletLines.join('\n'), assessmentSuggestions, sugesstionsAssessmentsList)
      }
    }

    return assessmentSuggestions
  }, [assessmentSuggestions, diagnosisName, noteStructureRef, sugesstionsAssessmentsList])

  const planSuggestionText = useMemo(() => {
    const selectedValues = new Set(formattedSelectedPlanSuggestionsStrings)
    const grouped = {}

    selectedPlanSuggestion.forEach((source) => {
      source.suggestions.forEach((suggestion, index) => {
        const optionKey = getPlanOptionKey(source, suggestion, index)
        const legacyOptionKey = getLegacyPlanOptionKey(source, suggestion)

        if (!selectedValues.has(optionKey) && !selectedValues.has(legacyOptionKey)) return

        const suggestionText = getSuggestionText(suggestion)
        if (!suggestionText) return

        if (!grouped[source.name]) grouped[source.name] = []
        if (!grouped[source.name].includes(suggestionText)) grouped[source.name].push(suggestionText)
      })
    })

    return Object.entries(grouped)
      .flatMap(([parent, children]) => [`• ${parent}`, ...children.map((child) => `\t• ${child}`)])
      .join('\n')
  }, [formattedSelectedPlanSuggestionsStrings, selectedPlanSuggestion])

  const handleSubmitModal = () => {
    const finalAssessmentSuggestions = mergeAssessmentSuggestionText(
      getAssessmentBulletText(sugesstionsAssessmentsList, selectedAssessmentSuggestionStrings).join('\n'),
      assessmentFinalValue,
      sugesstionsAssessmentsList
    )

    noteStructureRef.current = {
      ...noteStructureRef.current,
      assessment: {
        ...noteStructureRef.current.assessment,
        [diagnosisName]: {
          ...noteStructureRef.current.assessment?.[diagnosisName],
          assessmentSuggestions: finalAssessmentSuggestions,
          formattedSelectedSuggestionIdString: selectedIds.join('\n'),
        },
      },
      plans: {
        ...noteStructureRef.current.plans,
        [diagnosisName]: {
          ...noteStructureRef.current.plans?.[diagnosisName],
          planSuggestion: planSuggestionText,
          formattedSelectedPlanSuggestionsStrings,
        },
      },
    }
    setAssessmentFinalValue(finalAssessmentSuggestions)
    setAssessmentSuggestions(finalAssessmentSuggestions)
    setAddedChangesToAssessment?.((prev) => !prev)
    setVisible(false)
  }

  const openAssessmentSuggestionsModal = () => {
    const savedAssessmentSuggestions = noteStructureRef?.current?.assessment?.[diagnosisName]?.assessmentSuggestions || assessmentSuggestions || ''

    setActiveKey(1)
    setActiveKey2(2)
    setAssessmentFinalValue(
      mergeAssessmentSuggestionText(
        getAssessmentBulletText(sugesstionsAssessmentsList, selectedAssessmentSuggestionStrings).join('\n'),
        savedAssessmentSuggestions,
        sugesstionsAssessmentsList
      )
    )
    setVisible(true)
  }

  const labHtml = noteStructureRef?.current?.freeTypesEverything?.assessments?.[diagnosisName]?.LabImaging

  // function to check if HTML has real content
  const hasValidContent = (html) => {
    if (!html) return false

    const temp = document.createElement('div')
    temp.innerHTML = html

    return temp.textContent.trim().length > 0
  }
  return (
    <>
      {showTreatmentAsAccordion ? (
        <div>
          <div className="d-flex align-items-center gap-1">
            <h7>
              <b>Assessment</b>
            </h7>
          </div>
          <hr />

          {isTextInput ? (
            <div>
              {poa && (
                <p>
                  <strong className="text-dark fw-semibold">POA</strong>: {poa}
                </p>
              )}
              {assessment && (
                <p>
                  {' '}
                  <strong className="text-dark fw-semibold">Assessment</strong>: {assessment}
                </p>
              )}
              {freeType && (
                <p>
                  <strong className="text-dark fw-semibold">Free Type</strong>: {freeType}
                </p>
              )}
            </div>
          ) : (
            <div className="px-2">
              {assessment && (
                <div className="mb-4">
                  <label className="text-dark fw-semibold d-block" style={{ fontSize: '14px', marginBottom: '8px' }}>
                    Labs & Imaging
                  </label>

                  <div className=" mt-1" style={{ whiteSpace: 'pre-wrap' }}>
                    {assessment}
                  </div>
                </div>
              )}
              {assessmentSuggestions && (
                <div className="mb-4">
                  <div className="d-flex align-items-center gap-1" style={{ marginBottom: '8px' }}>
                    <label className="text-dark fw-semibold" style={{ fontSize: '14px' }}>
                      Assessment Suggestions
                    </label>
                  </div>

                  <div className=" mt-1" dangerouslySetInnerHTML={{ __html: renderAssessmentSuggestionHtml(displayedAssessmentSuggestions) }} />
                </div>
              )}

              {freeType && (
                <div>
                  <label className="text-dark fw-semibold" style={{ fontSize: '14px' }}>
                    Free Type
                  </label>

                  <div className=" mt-1" style={{ whiteSpace: 'pre-wrap' }}>
                    {freeType}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      ) : (
        <div>
          <div className="d-flex align-items-center gap-1">
            <h7>
              <b>Assessment</b>
            </h7>
          </div>
          <hr />

          {isTextInput ? (
            <div>
              {poa && (
                <p>
                  <strong className="text-dark fw-semibold">POA</strong>: {poa}
                </p>
              )}
              {assessment && (
                <p>
                  {' '}
                  <strong className="text-dark fw-semibold">Assessment</strong>: {assessment}
                </p>
              )}
              {freeType && (
                <p>
                  <strong className="text-dark fw-semibold">Free Type</strong>: {freeType}
                </p>
              )}
            </div>
          ) : (
            <div className="px-2">
              {/* <div className="mb-4">
                         <label className="text-dark fw-semibold" style={{ fontSize: "14px" }}>POA</label>
                         <CFormTextarea
                             className="bg-secondary border rounded shadow-sm mt-2"
                             rows={3}
                             value={poa}
                             onChange={(e) => { handlePoaChange(e.target.value) }}
                         />
                     </div> */}

              {
                <div className="mb-4">
                  <label className="text-dark fw-semibold d-block" style={{ fontSize: '14px', marginBottom: '8px' }}>
                    Labs & Imaging
                  </label>
                  {/* {console.log("noteStructureRef?.current?.freeTypesEverything?.assessments?.[diagnosisName]?.LabImaging",noteStructureRef?.current?.freeTypesEverything?.assessments?.[diagnosisName]?.LabImaging)} */}

                  {/* {noteStructureRef?.current?.freeTypesEverything?.assessments?.[diagnosisName]?.LabImaging && (
                    <div className="my-2">
                          <div
                            className="p-2"
                            style={{
                              background: '#f5f5f5',
                              borderRadius: '10px',
                              border: '1px solid #dee2e6',
                              color: '#6c757d',
                              cursor: 'not-allowed',
                              pointerEvents: 'none',
                              opacity: 0.8,
                              // userSelect: 'none' // optional if you want to prevent selection
                            }}
                            dangerouslySetInnerHTML={{
                              __html: noteStructureRef?.current?.freeTypesEverything?.assessments?.[diagnosisName]?.LabImaging
                            }}
                          ></div>
                    </div>
                  )} */}

                  {hasValidContent(labHtml) && (
                    <div className="my-2">
                      <div className="p-2 patient-theme-old-data patient-theme-old-data--readonly patient-theme-old-data--final-note" dangerouslySetInnerHTML={{ __html: labHtml }}></div>
                    </div>
                  )}
                  <Graytextarea height="20px" value={assessment} onChange={(e) => handleLabsChanges(e.target.value)} />
                </div>
              }
              {
                <div className="mb-4">
                  <div className="d-flex align-items-center gap-1" style={{ marginBottom: '8px' }}>
                    <label className="text-dark fw-semibold" style={{ fontSize: '14px' }}>
                      Assessment Suggestions
                    </label>

                    {isAllotedToProvider && (
                      <CFormLabel
                        className="d-flex mt-2 flex-column align-items-center justify-content-center shadow "
                        onClick={openAssessmentSuggestionsModal}
                        style={{
                          width: '30px',
                          height: '30px',
                          borderRadius: '20px',
                          background: 'var(--ui-color-primary, #2b7cd3)',
                          cursor: 'pointer',
                        }}
                      >
                        <Plus className="text-white" strokeWidth={2} size={15} />
                      </CFormLabel>
                    )}
                  </div>
                  {noteStructureRef?.current?.freeTypesEverything?.assessments?.[diagnosisName]?.assessmentSuggestions && (
                    <div className="my-2">
                      {/* <div
                        onClick={() => {
                          setTempAssessmentHtmlContent(noteStructureRef?.current?.freeTypesEverything?.assessments?.[diagnosisName]?.assessmentSuggestions)
                          setShowAssessmentEditHtml(true)
                        }}
                        className="p-4"
                        style={{ background: '#f6f6f6ff', borderRadius: '10px', cursor: 'pointer' }}
                        dangerouslySetInnerHTML={{
                          __html: noteStructureRef?.current?.freeTypesEverything?.assessments?.[diagnosisName]?.assessmentSuggestions,
                        }}
                      ></div> */}
                      <div
                        className="p-2 patient-theme-old-data patient-theme-old-data--readonly patient-theme-old-data--final-note"
                        style={{
                          whiteSpace: 'pre-wrap',
                          wordBreak: 'break-word',
                        }}
                        dangerouslySetInnerHTML={{
                          __html: noteStructureRef?.current?.freeTypesEverything?.assessments?.[diagnosisName]?.assessmentSuggestions,
                        }}
                      ></div>
                    </div>
                  )}
                  <div
                    className="patient-final-note-suggestions-textarea"
                    onClick={openAssessmentSuggestionsModal}
                    onFocus={openAssessmentSuggestionsModal}
                    tabIndex={0}
                    style={{
                      minHeight: '50px',
                      padding: '10px',
                      border: '1px solid var(--ui-dashboard-border-strong, #6f6f6f)',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      wordBreak: 'break-word',
                    }}
                  >
                    {displayedAssessmentSuggestions ? (
                      <div style={{ margin: 0 }} dangerouslySetInnerHTML={{ __html: renderAssessmentSuggestionHtml(displayedAssessmentSuggestions) }} />
                    ) : (
                      <span style={{ color: '#989898' }}>No suggestions</span>
                    )}
                  </div>
                </div>
              }
              {/* {diagnosisName === 'Cognitive Communication Deficit' && bimsScoreData && bimsScoreData.date && bimsScoreData.score && <div className="mb-4">
                         <label className="text-dark fw-semibold" style={{ fontSize: "14px" }}>Bims Score</label>
                         <CFormTextarea
                             className="bg-secondary border rounded shadow-sm mt-2"
                             rows={3}
                             disabled
                             value={bimsScoreData && bimsScoreData.date && bimsScoreData.score && `Bims Score: ${bimsScoreData.score}   recorded on Date: ${new Date(bimsScoreData.date).toLocaleDateString('en-US')}`}
                         />
                     </div>} */}
              <div>
                <label className="text-dark fw-semibold d-block" style={{ fontSize: '14px', marginBottom: '8px' }}>
                  Free Type
                </label>
                {/* <Graytextarea
                  height="20px"
                  value={freeType}
                  onChange={() => {
                    return
                  }}
                  onClick={() => {
                    setVisibleModalTempFreeType((p) => !p)
                  }}
                  rows={5}
                /> */}
                <div
                  onClick={() => {
                    setVisibleModalTempFreeType((p) => !p)
                  }}
                  style={{ cursor: 'pointer' }}
                >
                  {/* <BulletTextArea
                        value={freeType}
                        readOnly
                        height="60px"
                        style={{ pointerEvents: 'none' }}
                      /> */}
                  <BulletTextArea
                    onChange={() => {
                      return
                    }}
                    className="w-100"
                    height={'20px'}
                    value={freeType}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      <CModal className="modal-assessment assessment-suggestion-modal" visible={visible} onClose={() => setVisible(false)} aria-labelledby="ToggleBetweenModalsExample1">
        <CModalBody>
          <CNav className="d-flex align-items-center gap-2 assessment-suggestion-modal__tabs" variant="pills">
            <CNavItem className="">
              <CNavLink active={activeKey === 1} onClick={() => setActiveKey(1)} style={{ cursor: 'pointer' }}>
                Suggestion
              </CNavLink>
            </CNavItem>
            <CNavItem className="">
              <CNavLink active={activeKey === 2} onClick={() => setActiveKey(2)} style={{ cursor: 'pointer' }}>
                Assessment
              </CNavLink>
            </CNavItem>
          </CNav>
          <CTabContent>
            <CTabPane role="tabpanel" aria-labelledby="home-tab" className="mt-2" visible={activeKey === 1}>
              <CContainer className="p-0 border m-0 assessment-suggestion-modal__split">
                <CRow>
                  <CCol
                    style={{
                      width: '50%',
                      overflowY: 'scroll',
                      height: '80vh',
                      borderRight: '1px solid #e2e2e2',
                    }}
                    className="w-50 p-4 assessment-suggestion-modal__left-pane"
                  >
                    <div>{sugesstionsAssessmentsList && sugesstionsAssessmentsList?.length > 0 ? renderAccordions() : <div>No Suggestions Available</div>}</div>
                  </CCol>

                  <CCol
                    style={{
                      width: '50%',
                      overflowY: 'scroll',
                      height: '80vh',
                    }}
                    className="w-50 assessment-suggestion-modal__right-pane"
                  >
                    <p className="text-center p-2 fw-bold assessment-suggestion-modal__section-title">Add to plan</p>
                    <div className="d-flex align-items-center gap-2">
                      <button
                        type="button"
                        onClick={() => {
                          setActiveKey2(1)
                          setOrderModalVisible(true)
                        }}
                        className={`assessment-plan-toggle ${activeKey2 === 1 ? 'assessment-plan-toggle--active' : ''}`}
                      >
                        Orders
                      </button>
                      <button type="button" className={`assessment-plan-toggle ${activeKey2 === 2 ? 'assessment-plan-toggle--active' : ''}`} onClick={() => setActiveKey2(2)}>
                        Statements
                      </button>
                    </div>
                    {/* <CNav className='d-flex align-items-center gap-2' variant="pills" >
                                            <CNavItem className=''>
                                                <CNavLink
                                                    
                                                >
                                                    <CButton>
                                                        Orders
                                                    </CButton>
                                                </CNavLink>
                                            </CNavItem>
                                            <CNavItem className=''>
                                                <CNavLink
                                                    
                                                >
                                                    Suggestions
                                                </CNavLink>
                                            </CNavItem>
                                        </CNav> */}

                    <CTabContent>
                      <CTabPane role="tabpanel" aria-labelledby="home-tab" className="mt-2" visible={activeKey2 === 2}>
                        <div>
                          {selectedPlanSuggestion.map((item) => {
                            return (
                              <CAccordion flush key={item.key} className="assessment-suggestion-modal__accordion assessment-suggestion-modal__plan-accordion">
                                <CAccordionItem itemKey={1}>
                                  <CAccordionHeader className="" style={{ fontSize: '10px' }}>
                                    <div className="d-flex align-items-center gap-2">
                                      {item?.description && item?.description !== '' && (
                                        <CTooltip content={<div style={{ whiteSpace: 'pre-wrap' }}>{item.description}</div>}>
                                          <Info strokeWidth={1} size={16} />
                                        </CTooltip>
                                      )}
                                      {item.name}
                                    </div>
                                  </CAccordionHeader>
                                  <CAccordionBody>
                                    <div>
                                      {item.suggestions.length > 0 &&
                                        item.suggestions &&
                                        item.suggestions.map((listItem, optionIndex) => {
                                          const suggestionText = getSuggestionText(listItem)
                                          if (!suggestionText) return null
                                          const uniqueValue = getPlanOptionKey(item, listItem, optionIndex)
                                          const legacyValue = getLegacyPlanOptionKey(item, listItem)
                                          const descriptionKey = `plan-${item.key}-${optionIndex}`

                                          return (
                                            <div key={uniqueValue}>
                                              <div className="d-flex align-items-center gap-2">
                                                <CFormCheck
                                                  onChange={() => {
                                                    setFormattedSelectedPlanSuggestionsStrings((prevFormatted) => {
                                                      const isChecked = prevFormatted.includes(uniqueValue)
                                                      if (isChecked) return prevFormatted.filter((s) => s !== uniqueValue)

                                                      return [...prevFormatted.filter((s) => s !== legacyValue), uniqueValue]
                                                    })
                                                  }}
                                                  id={uniqueValue}
                                                  checked={formattedSelectedPlanSuggestionsStrings.includes(uniqueValue)}
                                                  label={suggestionText}
                                                />
                                                {listItem?.description && (
                                                  <span
                                                    className="d-inline-flex align-items-center"
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => setShowItemsDescriptions((prev) => (prev.includes(descriptionKey) ? prev.filter((key) => key !== descriptionKey) : [...prev, descriptionKey]))}
                                                  >
                                                    <Info strokeWidth={1} size={16} />
                                                  </span>
                                                )}
                                              </div>
                                              {listItem?.description && showItemsDescriptions.includes(descriptionKey) && <div style={{ color: 'orange', whiteSpace: 'pre-line', fontSize: '12px', padding: '8px 10px' }}>{listItem.description}</div>}
                                            </div>
                                          )
                                        })}
                                    </div>
                                  </CAccordionBody>
                                </CAccordionItem>
                              </CAccordion>
                            )
                          })}
                        </div>
                      </CTabPane>
                    </CTabContent>
                  </CCol>
                </CRow>
              </CContainer>
            </CTabPane>
            <CTabPane role="tabpanel" aria-labelledby="profile-tab" visible={activeKey === 2}>
              <BulletTextArea assessmentEditor onChange={(e) => setAssessmentFinalValue(e.target.value)} value={assessmentFinalValue} />
            </CTabPane>
          </CTabContent>
        </CModalBody>
        <CModalFooter>
          <CButton
            onClick={() => {
              setVisible(false)
              setShowItemsDescriptions([])
            }}
            color="secondary"
          >
            Close
          </CButton>
          <CButton
            className="assessment-suggestion-modal__clear-btn"
            onClick={() => {
              setSelectedPlanSuggestion([])
              setSelectedAssessmentSuggestionString([])
              setSelectedId([])
              setSelectedOrder([])
              setAssessmentFinalValue('')
              setFormattedSelectedPlanSuggestionsStrings([])
              setAssessmentSuggestions('')
              noteStructureRef.current = {
                ...noteStructureRef.current,
                assessment: {
                  ...noteStructureRef.current.assessment,
                  [diagnosisName]: {
                    ...noteStructureRef.current.assessment?.[diagnosisName],
                    assessmentSuggestions: '',
                    formattedSelectedSuggestionIdString: '',
                  },
                },
                plans: {
                  ...noteStructureRef.current.plans,
                  [diagnosisName]: {
                    ...noteStructureRef.current.plans?.[diagnosisName],
                    planSuggestion: '',
                    formattedSelectedPlanSuggestionsStrings: [],
                  },
                },
              }
            }}
            color="secondary"
          >
            Clear All
          </CButton>
          <CButton color="primary" className="ui-action-btn ui-action-btn--primary" onClick={handleSubmitModal}>
            Save
          </CButton>
        </CModalFooter>
      </CModal>

      <CModal className="assessment-order-modal" size="lg" backdrop="static" visible={orderModalVisible} onClose={() => setOrderModalVisible(false)} aria-labelledby="StaticBackdropExampleLabel">
        <FetchOrderForAssessment
          patientID={patientID}
          noteID={noteID}
          diagnosisName={diagnosisName}
          toggleModal={() => {
            setOrderModalVisible((p) => !p)
            setActiveKey2(1)
          }}
          fetchOrdersAgain={() => setAddedChangesToAssessment?.((prev) => !prev)}
          selectedOrder={selectedOrder}
        />
      </CModal>

      {/* freetype modal */}
      <CModal className="patient-theme-modal patient-note-form-modal assessment-theme__modal" backdrop="static" visible={visibleModalTempFreeType} onClose={() => setVisibleModalTempFreeType(false)} aria-labelledby="LiveDemoExampleLabel">
        <CModalHeader>
          <CModalTitle id="LiveDemoExampleLabel">Add Assessment Freetype</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <BulletTextArea
            placeholder="Enter freetype"
            value={tempFreeType}
            rows={10}
            onChange={(e) => setTempFreeType(e.target.value)}
            style={{
              minHeight: '320px',
              border: '1px solid var(--ui-dashboard-border-strong, #3a3a3a)',
              background: 'var(--ui-bg-inset, #1b1b1b)',
              color: 'var(--ui-text-primary, #ffffff)',
            }}
          />
        </CModalBody>
        <CModalFooter>
          <CButton variant="outline" color="secondary" onClick={() => setVisibleModalTempFreeType(false)}>
            Close
          </CButton>
          <CButton color="primary" onClick={handleSaveFreetype}>
            Save
          </CButton>
        </CModalFooter>
      </CModal>

      <CModal size="lg" visible={showEditHtml} onClose={() => setShowEditHtml(false)} aria-labelledby="OptionalSizesExample2">
        <CModalHeader>
          <CModalTitle id="OptionalSizesExample2">Edit Labs & Imaging Free Type</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <Editor
            onChange={(e) => {
              setTempHtmlContent(e.target.value)
            }}
            containerProps={{
              style: {
                width: '100%',
                background: '#f9f9f9',
                border: 0,
                height: '100%',
                minHeight: 'unset',
              },
            }}
            value={tempHtmlContent}
          >
            <tooltip />
          </Editor>
        </CModalBody>
        <CModalFooter>
          <CButton variant="outline" color="secondary" onClick={() => setShowEditHtml(false)}>
            Close
          </CButton>
          <CButton
            variant="outline"
            color="primary"
            onClick={() => {
              noteStructureRef.current = {
                ...noteStructureRef.current,
                freeTypesEverything: {
                  ...noteStructureRef.current?.freeTypesEverything,
                  assessments: {
                    ...noteStructureRef.current?.freeTypesEverything?.assessments,
                    [diagnosisName]: {
                      ...noteStructureRef.current?.freeTypesEverything?.assessments?.[diagnosisName],
                      LabImaging: tempHtmlContent,
                    },
                  },
                },
              }
              saveTreatsShell(false)
              setShowEditHtml(false)
            }}
          >
            Save
          </CButton>
        </CModalFooter>
      </CModal>

      <CModal size="lg" visible={showAssessmentEditHtml} onClose={() => setShowAssessmentEditHtml(false)} aria-labelledby="OptionalSizesExample2">
        <CModalHeader>
          <CModalTitle id="OptionalSizesExample2">Edit Assessment Suggestions Free Type</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <Editor
            onChange={(e) => {
              setTempAssessmentHtmlContent(e.target.value)
            }}
            containerProps={{
              style: {
                width: '100%',
                background: '#f9f9f9',
                border: 0,
                height: '100%',
                minHeight: 'unset',
              },
            }}
            value={tempAssessmentHtmlContent}
          >
            <tooltip />
          </Editor>
        </CModalBody>
        <CModalFooter>
          <CButton variant="outline" color="secondary" onClick={() => setShowAssessmentEditHtml(false)}>
            Close
          </CButton>
          <CButton
            variant="outline"
            color="primary"
            onClick={() => {
              noteStructureRef.current = {
                ...noteStructureRef.current,
                freeTypesEverything: {
                  ...noteStructureRef.current?.freeTypesEverything,
                  assessments: {
                    ...noteStructureRef.current?.freeTypesEverything?.assessments,
                    [diagnosisName]: {
                      ...noteStructureRef.current?.freeTypesEverything?.assessments?.[diagnosisName],
                      assessmentSuggestions: tempAssessmentHtmlContent,
                    },
                  },
                },
              }
              saveTreatsShell(false)
              setShowAssessmentEditHtml(false)
            }}
          >
            Save
          </CButton>
        </CModalFooter>
      </CModal>
          <CModal
  visible={showMediaModel}
  onClose={() => setShowMediaModel(false)}
  size="lg"
  alignment="center"
  backdrop="static"
>
  <CModalHeader closeButton>
   
  </CModalHeader>

  <CModalBody>
    {file.length > 0 ? (
      <div className="d-flex flex-column gap-3">
        {file.map((item, index) => {
          const isImage = item.type === 'image' ||
            /\.(jpg|jpeg|png|gif|webp|bmp)$/i.test(item.url)

          return (
            <div
              key={`${item.url}-${index}`}
              className="p-2"
            >
              {isImage ? (
                <a href={item.url} target="_blank" rel="noreferrer">
                  <img
                    src={item.url}
                    alt={item.fileName || 'Attachment'}
                    style={{
                      maxWidth: '100%',
                      maxHeight: '350px',
                      objectFit: 'contain',
                    }}
                  />
                </a>
              ) : (
                <div className="d-flex justify-content-between align-items-center">
                  <span>{item.fileName || 'Attached file'}</span>
                  <a
                    href={item.url}
                    target="_blank"
                    rel="noreferrer"
                  >
                    View / Open
                  </a>
                </div>
              )}
            </div>
          )
        })}
      </div>
    ) : (
      <p className="text-center mb-0">No attached files found.</p>
    )}
  </CModalBody>
</CModal>
    </>
  )
}

export default AssessmentFinalNote
